import { PrivacyPolicy } from "src/components/termsAndUse/privacyPolicy";

export default PrivacyPolicy;
